import classnames from 'classnames';
import { type ComponentPropsWithoutRef, type ElementType } from 'react';

import styles from './render-html.module.scss';

type PolymorphicProps<E extends ElementType> = ComponentPropsWithoutRef<E> & {
  as?: E;
};

type RenderHTMLProps<T extends ElementType> = PolymorphicProps<T> & {
  html: null | string | undefined;
};

const defaultElement = 'div';

export const RenderHTML = <T extends ElementType = typeof defaultElement>({
  as,
  className,
  html,
  ...rest
}: RenderHTMLProps<T>) => {
  if (!html) {
    return null;
  }

  const Component = as || defaultElement;

  return (
    <Component
      className={classnames(className, styles.wrapper)}
      dangerouslySetInnerHTML={{ __html: html }}
      {...rest}
    />
  );
};
